module.exports = __webpack_public_path__ + "static/media/edit.b3be13d0.svg";